export default __webpack_public_path__ + "static/media/Jobvious_white_logo_base.90036353.svg";